import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import nameStringFn from '../../../data/nameStringFn';
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';
import styled from 'styled-components';

const ButtonWrapper =styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`

const OTReadOnlyrow = ({k, row, onClickEdit,handleDeleteClick,
   page, rowsPerPage, tableFontSize, SubmitButton,users, editCategory}) =>{
  
  console.log(row?.unitHead)
  console.log(row?.unitHead? row?.unitHead?.length:"Not Defined")
  console.log(row?.unitHead?.length? users[row?.unitHead]:"No Length")

    return(        
      <>
        <TableRow key={k} name={row.categ}>
          <TableCell component="th" scope="row" sx={{ fontSize: tableFontSize}}>
            {(page)*(rowsPerPage)+k+1}
          </TableCell>
        
          <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
            {row?.name}
          </TableCell>

          <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
            {row?.type}
          </TableCell>
      
          <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
            {row?.level}                  
          </TableCell>
          
          <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
            {row?.superioroffice?.length? row?.superioroffice: "Not Applicable" }
          </TableCell>

          <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
            {(row?.unitHead?.length && users[row?.unitHead])? nameStringFn(users[row?.unitHead]) : "Not Available" }
          </TableCell>

          <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
            {row?.Bo?.length? nameStringFn(users[row?.Bo]) : "Not Available"}
          </TableCell>         

          <TableCell align="left" sx={{ fontSize: tableFontSize}}>
            <ButtonWrapper>
              <SubmitButton type="button" style={{marginRight:'10px', backgroundColor:"#ed6c02", color:"lightgreen", height:"35px", margin:"0px"}} onClick ={(e)=>onClickEdit(e,k,row)}>Edit
              </SubmitButton>
              <SubmitButton type="button" style={{marginRight:'10px', backgroundColor:"#D32F2F", color:"lightgreen", height:"35px"}} onClick ={(e)=>handleDeleteClick(e,k, row.id)}>Delete
              </SubmitButton> 
            </ButtonWrapper>                                                
          </TableCell>
        </TableRow>     
      </>        
    )
}

export default OTReadOnlyrow;